var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 61",
    width: 23,
    height: 61,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 23,
    height: 61,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAA9CAMAAABxwwLCAAAAAXNSR0IB2cksfwAAAPZQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////SKX8DgAAAFJ0Uk5TABtQR9oTn/9OGeCtYOkpA7Rz+MoJgUELzUbhIJlkFcABZfk2to8w99gYfVUF1Uz77yycgBzozxBivKc18OYjbw7SxEk8pJreX7q5Ho78O38hFhRoSbsAAADhSURBVHic7dHpQgFhFMbxI8sTIiJZk6hsUUybXSG03//NMO+MmXe7gD74f3t+H88hcvIckDavz6/1AA51HAwhrPMjIBJV+TgGIK569GTriaTipzBLyXyWZh6QPcMY2ZzkectREPk8YnvxQvCSzbgsC17ZOa54vr5xvFrjvA63hsvNW85jrrfanN/dO94BX3fHxoPgj0+2P0PMa/uL5D2L+wPJhyPmXciNTZ5MFX813/amMDDb+lzjC6JcVuPvHipoGFjSSutrMj5Y/k9zfn0HrWk4t/th/ktye+e8/bf3/+0bRxE1yx7wBAsAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Fl\\xE8che Lieux d'int\\xE9r\\xEAt",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow-1.e3ca9852df6cefcd8112d46de308101e.svg";
export { ForwardRef as ReactComponent };